// Le proche choisit, à sa mise en place, s'il reçoit un message à chaque
// « Prise » (#27, option B). Défaut : seulement en cas de problème. Un seul
// bouton principal ; le choix se change ensuite depuis son écran.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Bouton, Erreur, Texte, Titre } from '../components/base';
import { Choix } from '../components/champs';
import { api, type Confirmation } from '../lib/api';
import { CLES } from '../lib/requetes';

export function ChoixConfirmation({
  actuel,
  onEnregistre,
}: Readonly<{ actuel: Confirmation | null; onEnregistre?: () => void }>) {
  const { t } = useTranslation();
  const client = useQueryClient();
  const [choix, setChoix] = useState<Confirmation>(actuel ?? 'probleme');
  const enregistrer = useMutation({
    mutationFn: () => api.choisirConfirmation(choix),
    onSuccess: async () => {
      await client.invalidateQueries({ queryKey: CLES.moi });
      onEnregistre?.();
    },
  });
  return (
    <section>
      <Titre>{t('confirmation.titre')}</Titre>
      <Texte>{t('confirmation.intro')}</Texte>
      <Choix
        legende={t('confirmation.legende')}
        nom="confirmation"
        options={[
          {
            valeur: 'probleme',
            libelle: t('confirmation.probleme'),
            aide: t('confirmation.problemeAide'),
          },
          {
            valeur: 'chaque-prise',
            libelle: t('confirmation.chaquePrise'),
            aide: t('confirmation.chaquePriseAide'),
          },
        ]}
        valeur={choix}
        onChange={setChoix}
      />
      <Bouton
        className="mt-8"
        disabled={enregistrer.isPending}
        onClick={() => enregistrer.mutate()}
      >
        {actuel === null ? t('confirmation.continuer') : t('confirmation.enregistrer')}
      </Bouton>
      {enregistrer.isError && <Erreur>{t('erreur.action')}</Erreur>}
    </section>
  );
}
